<template>
  <div>
    <vxe-toolbar v-if="isClaim || (canEdit && !isClaim)">
      <template v-slot:buttons>
        <vxe-button
          v-if="isClaim || (canEdit && !isClaim)"
          :disabled="!canEdit"
          @click="insertRow()"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >新增</vxe-button
        >
        <vxe-button
          v-if="isClaim || (canEdit && !isClaim)"
          :disabled="!canEdit"
          @click="deleteRow()"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >{{ $t('xTable.delete') }}</vxe-button
        >
        <vxe-button
          @click="handleSave()"
          v-if="isClaim"
          :disabled="!canEdit"
          type="primary"
          icon="el-icon-files"
          class="vxe-btn-primary"
          >{{ $t('xTable.save') }}</vxe-button
        >
        <!-- 收款认领 一次认领中取消代码则二次认领按钮可用 -->
        <vxe-button
          @click="handleSecondClaim()"
          v-if="isClaim"
          :disabled="secondClaimButonFlag"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >半自动二次认领</vxe-button
        >
        <!-- <vxe-button
          @click="handleAssociatedPayment()"
          v-if="isClaim && sysConfigFlag != 'Y'"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >关联付款单</vxe-button
        >
        <vxe-button
          @click="handleSettleBatch()"
          v-if="isClaim && sysConfigFlag != 'Y'"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >关联结算批次</vxe-button
        > -->
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="column"
      :edit-rules="canEdit ? rules : {}"
      :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeRowMethod }"
      :valid-config="{ autoPos: true, message: 'inline' }"
      show-footer
      :footer-method="footerMethod"
      max-height="300px"
    >
    </vxe-grid>
    <!-- 二次认领弹框海宁 -->
    <second-claim-dialog-HN
      v-if="sysConfigFlag == 'Y'"
      :departmentList="departmentList"
      @getAllData="getAllData"
      ref="secondClaimDialog"
    ></second-claim-dialog-HN>
    <!-- 二次认领弹框 -->
    <second-claim-dialog
      v-else
      :departmentList="departmentList"
      @getAllData="getAllData"
      ref="secondClaimDialog"
    ></second-claim-dialog>
    <!-- 关联付款单 -->
    <payment-dialog ref="paymentDialog"></payment-dialog>
    <!-- 关联结算批次 -->
    <settlement-batch ref="settlementBatch" @updateSettle="updateSettle"></settlement-batch>
    <secondClaimDialog1
      ref="secondClaimDialog1Ref"
      :businessType="businessType"
      :formData="formData"
      :departmentList="departmentList"
    />
  </div>
</template>
<script>
  // import { mapState } from 'vuex';
  // import SearchTable from '@/components/form-item/search-table';
  import secondClaimDialog from './secondClaimDialog';
  import secondClaimDialog1 from './secondClaimDialog1';
  import secondClaimDialogHN from './secondClaimDialogHN';
  import paymentDialog from './paymentDialog';
  import API from '@/api/capitalCenter/receivablesManage';
  import SettlementBatch from '@/components/SettlementBatch';
  export default {
    name: 'receivablesClaimInfo',
    props: [
      'departmentList',
      'canEdit',
      'firstUnClaimedAmount', // 认领详情-一次未认领金额
      'secondUnClaimAmountList', // 二次未认领金额
      'formData', // 表单信息
      'businessType', // 业务类型
    ],
    components: {
      // SearchTable,
      secondClaimDialog,
      secondClaimDialog1,
      secondClaimDialogHN,
      paymentDialog,
      SettlementBatch,
    },
    computed: {
      partnerList() {
        return [
          {
            value: this.customerNo || this.claimPartnerNo || this.formData.payerCode,
            label: this.customerName || this.claimPartnerName || this.formData.payerName,
          },
        ];
      },
      column() {
        return [
          { type: 'checkbox', width: 50 },
          { type: 'seq', title: '行项目号', width: 90 }, // 序号

          ...(!['03', '04'].includes(this.businessType)
            ? [
                {
                  // 收款类别
                  field: 'receivedType',
                  title: '收款类别',
                  width: 150,
                  editRender: {
                    name: 'ElSelect',
                    options:
                      this.businessType == '04'
                        ? this.dictListMap.property_settlement_cost
                        : this.receivedTypeOptions,
                    props: {
                      clearable: true,
                      filterable: true,
                    },
                    events: { change: (obj) => this.updateCol(obj.row, 'receivedType') },
                  },
                },
              ]
            : []),

          {
            // 客户
            field: 'customerNo',
            title: '客户',
            width: 150,
            ...(this.formData.isAnotherPay == true || this.formData.isAnotherPay == 'Y'
              ? {
                  // 代付勾选时，可更改客户
                  // 客户和供应商互斥 //当选择代付后，下方一次认领信息的客户要限制，不能改成供应商 供应商同理 ID1001346
                  ...(!this.addRowObj.claimPartnerNo && this.formData.payerType != 'HZHB02'
                    ? {
                        editRender: { name: 'ElInput', props: { clearable: true } },
                        slots: {
                          default: ({ row }) => {
                            return [<span>{row.customerName}</span>];
                          },
                          edit: ({ row }) => {
                            return [
                              <search-table
                                searchType="customer"
                                isMultiple={true}
                                currentValue={row['customerName']}
                                checkRowKeys={[row['customerNo']]}
                                disabled={
                                  ['RT07', 'RT15', 'RT16', '08', '14'].indexOf(row.receivedType) !=
                                  -1
                                }
                                onInput={(val) => this.chooseTable(val, row, 'customerNo')}
                                extraData={{
                                  companyCode: this.formData.registerCompanyCode,
                                }}
                              ></search-table>,
                            ];
                          },
                        },
                      }
                    : {}),
                }
              : {
                  editRender: { name: 'ElInput', props: { clearable: true } },
                  slots: {
                    default: ({ row }) => {
                      return [<span>{row.customerName}</span>];
                    },
                    edit: ({ row }) => {
                      return [
                        <search-table
                          searchType="customer"
                          disabled={
                            ['RT07', 'RT15', 'RT16', '08', '14'].indexOf(row.receivedType) != -1
                          }
                          isMultiple={true}
                          currentValue={row['customerName']}
                          checkRowKeys={[row['customerNo']]}
                          onInput={(val) => this.chooseTable(val, row, 'customerNo')}
                          extraData={{
                            companyCode: this.formData.registerCompanyCode,
                          }}
                        ></search-table>,
                      ];
                    },
                  },
                }),
          },
          ...(this.sysConfigFlag == 'Y'
            ? [
                {
                  // 业务属性
                  field: 'businessType',
                  title: '业务属性',
                  width: 150,
                  editRender: {
                    name: 'ElSelect',
                    options: this.$baseRequest.getDictListMapByType('hn_order_businessType'),
                    props: {
                      clearable: true,
                      filterable: true,
                    },
                  },
                },
              ]
            : []),
          {
            field: 'claimPartnerNo',
            title: this.$t('receivablesManage.receivablesClaimInfo.claimPartnerNo'),
            width: 150, // 供应商
            // 客户和供应商互斥  //当选择代付后，下方一次认领信息的客户要限制，不能改成供应商 ID1001346
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{row.claimPartnerName}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="supplier"
                    isMultiple={true}
                    currentValue={row.claimPartnerName}
                    disabled={['RT07', 'RT15', 'RT16', '08', '14'].indexOf(row.receivedType) == -1}
                    checkRowKeys={[row.claimPartnerNo]}
                    onInput={(val) => this.chooseTable(val, row, 'claimPartnerNo')}
                    extraData={{
                      companyCode: this.formData.registerCompanyCode,
                    }}
                  ></search-table>,
                ];
              },
            },
          },

          {
            // 部门
            field: 'claimDepartmentNo',
            title: this.$t('receivablesManage.receivablesClaimInfo.claimDepartmentNo'),
            width: 150,
            editRender: {
              name: 'ElSelect',
              options: this.departmentList,
              props: {
                clearable: true,
                filterable: true,
              },
              events: { change: this.chooseDepartment },
            },
          },
          {
            field: 'claimDepartmentName',
            title: this.$t('receivablesManage.receivablesClaimInfo.claimDepartmentName'),
            width: 150,
          }, // 部门描述
          /* ...(this.sysConfigFlag == 'Y'
            ? []
            : [
                {
                  // 结算批次
                  field: 'settleBatchNo',
                  title: this.$t('receivablesManage.receivablesClaimInfo.settleBatchNo'),
                  width: 150,
                  editRender: { name: 'ElInput', props: { clearable: true } },
                  slots: {
                    default: ({ row }) => {
                      return [<span>{row.settleBatchNo}</span>];
                    },
                    edit: ({ row }) => {
                      return [
                        <search-table
                          searchType="settle"
                          isMultiple={true}
                          currentValue={row.settleBatchNo}
                          checkRowKeys={[row.settleBatchNo]}
                          onInput={(val) => this.chooseTable(val, row, 'settleBatchNo')}
                          disabled={!row.claimDepartmentNo}
                          extraData={{
                            settleDepartmentNo: row.claimDepartmentNo,
                          }}
                        ></search-table>,
                      ];
                    },
                  },
                },
              ]),
          {
            // 形式发票金额
            field: 'originProformaInvoiceAmount',
            title: this.$t('receivablesManage.receivablesClaimInfo.originProformaInvoiceAmount'),
            width: 150,
            // 认领详情-形式发票金额存在时，形式发票金额手动填写，收款金额根据形式发票金额自动计算
            ...(this.formData.originProformaInvoiceAmount
              ? {
                  editRender: {
                    name: 'ElInput',
                    props: {
                      clearable: true,
                    },
                  },
                }
              : {}),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.originProformaInvoiceAmount)}
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.originProformaInvoiceAmount}
                    max={this.firstUnClaimedAmount['originProformaInvoiceAmount']}
                    min={0}
                    onInput={(val) => this.chooseTable(val, row, 'originProformaInvoiceAmount')}
                    onChange={(val) =>
                      this.verifyAmount(val, row, 'originProformaInvoiceAmount', true)
                    }
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            // 形式发票金额（本币）
            field: 'localProformaInvoiceAmount',
            title: this.$t('receivablesManage.receivablesClaimInfo.localProformaInvoiceAmount'),
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.localProformaInvoiceAmount)}
                  </span>,
                ];
              },
            },
          }, */
          {
            // 收款金额
            field: 'originReceiveMoneyAmount',
            title: this.$t('receivablesManage.receivablesClaimInfo.originReceiveMoneyAmount'),
            width: 150,
            // 认领详情-形式发票金额不存在时，形式发票金额禁止填写，收款金额手动填写
            ...(!this.formData.originProformaInvoiceAmount
              ? {
                  editRender: {
                    name: 'ElInput',
                    props: {
                      clearable: true,
                    },
                  },
                }
              : {}),
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.originReceiveMoneyAmount)}</span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.originReceiveMoneyAmount}
                    max={this.firstUnClaimedAmount['originReceiveMoneyAmount']}
                    min={0}
                    onInput={(val) => this.chooseTable(val, row, 'originReceiveMoneyAmount')}
                    onChange={(val) =>
                      this.verifyAmount(val, row, 'originReceiveMoneyAmount', true)
                    }
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            // 收款金额（本币）
            field: 'localReceiveMoneyAmount',
            title: this.$t('receivablesManage.receivablesClaimInfo.localReceiveMoneyAmount'),
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.localReceiveMoneyAmount)}</span>,
                ];
              },
            },
          },
          /* {
            // 国内银行扣费
            field: 'originDomesticBankDeductFee',
            title: this.$t('receivablesManage.receivablesClaimInfo.originDomesticBankDeductFee'),
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.originDomesticBankDeductFee)}
                  </span>,
                ];
              },
            },
          },
          {
            // 国内银行扣费（本币）
            field: 'localDomesticBankDeductFee',
            title: this.$t('receivablesManage.receivablesClaimInfo.localDomesticBankDeductFee'),
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.localDomesticBankDeductFee)}
                  </span>,
                ];
              },
            },
          },
          {
            // 国外银行扣费
            field: 'originForeignBankDeductFee',
            title: this.$t('receivablesManage.receivablesClaimInfo.originForeignBankDeductFee'),
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.originForeignBankDeductFee)}
                  </span>,
                ];
              },
            },
          },
          {
            // 国外银行扣费（本币）
            field: 'localForeignBankDeductFee',
            title: this.$t('receivablesManage.receivablesClaimInfo.localForeignBankDeductFee'),
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.localForeignBankDeductFee)}</span>,
                ];
              },
            },
          }, */
        ];
      },
      secondClaimButonFlag() {
        let fromFlag =
          ((this.formData.isAnotherPay == true || this.formData.isAnotherPay == 'Y') &&
            this.formData.financeAuditStatus == null) ||
          (this.formData.financeAuditStatus != '002' && this.formData.financeAuditStatus != null);
        //应收票据托收贴现，收款登记不允许二次认领
        let rowFlag = false;
        const selectedList = this.$refs.table.getSelectRecords();
        if (selectedList[0]) {
          rowFlag = ['RT01'].includes(selectedList[0].receivedType);
        }
        // 新增园区仓储、园区物业、监管单
        if (['03', '04', '05'].includes(this.businessType)) {
          return false;
        }
        console.log(this.businessType, '------>>', selectedList);
        if (this.businessType != '01') {
          return true;
        }
        return fromFlag || !rowFlag;
      },
    },
    data() {
      // 客户和供应商二者选其一必填校验
      const customerNoValid = (rule, cellValue, callback, { row }) => {
        if (['RT07', 'RT15', 'RT16', '08', '14', '15'].indexOf(row.receivedType) != -1) {
          callback();
        } else {
          if (!cellValue && !row.claimPartnerNo) {
            callback(new Error(this.$t('receivablesManage.placeholder.customerNamePlaceholder')));
          } else {
            callback();
          }
        }
      };
      const claimPartnerNoValid = (rule, cellValue, callback, { row }) => {
        if (['RT07', 'RT15', 'RT16', '08', '14', '15'].indexOf(row.receivedType) == -1) {
          callback();
        } else {
          if (!cellValue && !row.customerNo) {
            callback(
              new Error(this.$t('receivablesManage.placeholder.claimPartnerNamePlaceholder'))
            );
          } else {
            callback();
          }
        }
      };
      const amountValid = (rule, cellValue, callback, { row }) => {
        if (row.originProformaInvoiceAmount == 0 && row.originReceiveMoneyAmount == 0) {
          callback(new Error('形式发票金额和收款金额不能同时为0！'));
        } else {
          callback();
        }
      };
      const businessTypeValid = (rule, cellValue, callback, { row }) => {
        if (
          !cellValue &&
          this.sysConfigFlag == 'Y' &&
          ['RT02', 'RT03'].indexOf(row.receivedType) == -1
        ) {
          callback(new Error('请选择业务属性'));
        } else {
          callback();
        }
      };
      // 收款类别
      const receivedTypeValid = (rule, cellValue, callback, { row }) => {
        if (['RT07', 'RT15', 'RT16', '08', '14'].indexOf(cellValue) == -1 && !row['customerNo']) {
          row['claimPartnerNo'] = null;
          row['claimPartnerName'] = null;
          this.addRowObj.claimPartnerNo = null;
          this.addRowObj.claimPartnerName = null;
        } else if (
          ['RT07', 'RT15', 'RT16', '08', '14'].indexOf(cellValue) != -1 &&
          !row['claimPartnerNo']
        ) {
          row['customerNo'] = null;
          row['customerName'] = null;
          this.addRowObj.customerNo = null;
          this.addRowObj.customerName = null;
        } else {
          callback();
        }
      };
      return {
        isClaim: false,
        tableData: [],
        tableDataInit: [],
        secondTableDataInit: [],
        secondTableData: [],
        del: [],
        addRowObj: {
          customerNo: null,
          customerName: null,
          claimPartnerNo: null,
          claimPartnerName: null,
          businessType: null, // 业务属性，海宁
          receivedType: null, // 收款类别默认为货款
          claimDepartmentNo: null,
          claimDepartmentName: null,
          settleBatchNo: null, // 结算批次
          originProformaInvoiceAmount: null,
          localProformaInvoiceAmount: null,
          originReceiveMoneyAmount: null,
          localReceiveMoneyAmount: null,
          originDomesticBankDeductFee: null,
          localDomesticBankDeductFee: null,
          originForeignBankDeductFee: null,
          localForeignBankDeductFee: null,
        },
        customerNo: null,
        customerName: null,
        claimPartnerNo: null,
        claimPartnerName: null,
        rules: {
          //businessType: [{ required: true, message: '请选择业务属性', trigger: ["blur", "change"] }],
          receivedType: [
            {
              required: true,
              message: this.$t('receivablesManage.placeholder.receivedTypePlaceholder'),
              trigger: ['blur', 'change'],
            },
            { validator: receivedTypeValid },
          ],
          claimDepartmentNo: [
            {
              required: true,
              message: this.$t('receivablesManage.placeholder.claimDepartmentNoPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          customerNo: [{ validator: customerNoValid }],
          claimPartnerNo: [{ validator: claimPartnerNoValid }],
          originReceiveMoneyAmount: [
            {
              required: true,
              message: this.$t('receivablesManage.placeholder.originReceiveMoneyAmountPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          originProformaInvoiceAmount: [{ validator: amountValid }],
          // originReceiveMoneyAmount: [{ validator: amountValid }],
          businessType: [{ validator: businessTypeValid }],
        },
        receivedTypeToCustomer: ['01', '02', '03', '04', '05', '09', '11'], // 货款、应收票据贴现、应收票据托收、信用证收款、客户保证金、客户退款、资金调拨-向下调拨、其他费用
        receivedTypeToSupplier: ['07', '08', '14', '10'], // 供应商退款、期货保证金退款、资金调拨-向上归集、政府补助
        sysConfigFlag: null, // 系统配置标识 海宁：Y
        receivedTypeOptions: [],
      };
    },
    mounted() {
      this.isClaim = this.$route.name == 'claim' ? true : false;
      this.resolveTableData(); // 初始一行表格空数据
    },
    methods: {
      computedReceivedTypeOptions(businessType) {
        console.log('当前类型', businessType, this.dictListMap.parkReceivedType);
        /**
       * { label: '贸易', value: '01' },
              { label: '多式联运', value: '02' },
              { label: '园区仓储', value: '03' },
              { label: '园区物业', value: '04' },
              { label: '监管单', value: '05' },
       */
        if (businessType == '01') {
          let options = this.$baseRequest.getDictListMapByType('receivedType');
          //【ID1002141】海宁收款认领增加类别  收款一次认领类别增加“预收账款”
          if (this.sysConfigFlag == 'Y') {
            options.push({ label: '预收账款', value: 'RT17' });
          }
          console.log(options);
          //【ID1000806】本部收款认领收款类别增加“供应商保证金”，认领到供应商保证金类型的不可关联客户，只可认领到“供应商或者合作伙伴类型”的合作伙伴
          if (
            this.sysConfigFlag == 'N' &&
            !this.addRowObj.customerNo &&
            this.formData.payerType != 'HZHB01'
          ) {
            options.push({ label: '供应商保证金', value: 'RT18' });
          }
          this.receivedTypeOptions = options;
        } else if (businessType == '02') {
          console.log('多式联运下拉框');
          this.receivedTypeOptions = this.dictListMap.multimodalTransportReceivedType;
        } else if (businessType == '03') {
          console.log('园区仓储下拉框');
          this.receivedTypeOptions = this.dictListMap.warehouseContractGuizhongLoadExpenseList;
        } else if (businessType == '04') {
          console.log('园区物业下拉框');
          this.receivedTypeOptions = this.dictListMap.parkReceivedType;
        } else if (businessType == '05') {
          console.log('监管单下拉框');
          this.receivedTypeOptions = this.dictListMap.parkReceivedType;
        } else {
          console.log(businessType, '等待开发中');
          this.receivedTypeOptions = [];
        }
      },
      async getSysConfigByCompany(companyCode) {
        // 系统配置判断
        let res = await this.$baseRequest.getSysConfigByCompany({
          code: 'FUND_COLLECTION_HN',
          companyCode,
        });
        if (res) {
          this.sysConfigFlag = res;
          this.$emit('sysConfigFlagChange', res);
        }
      },
      // 初始一行表格空数据
      resolveTableData() {
        let returnAmountProps = [
          'originProformaInvoiceAmount',
          'localProformaInvoiceAmount',
          'originReceiveMoneyAmount',
          'localReceiveMoneyAmount',
          'originDomesticBankDeductFee',
          'localDomesticBankDeductFee',
          'originForeignBankDeductFee',
          'localForeignBankDeductFee',
        ];
        let addRowObj = { ...this.addRowObj };
        returnAmountProps.map((item) => {
          if (this.formData[item]) {
            addRowObj[item] = this.formData.receiveStatus == '01' ? this.formData[item] : 0;
          } else {
            addRowObj[item] = 0;
          }
        });
        for (var i = 0; i < 1; i++) {
          this.tableData.push(addRowObj);
        }
      },
      // 一次认领初始化
      activeRowMethod() {
        return this.canEdit;
      },
      insertRow(row) {
        let tableData = this.$refs.table.getTableData().fullData;
        if (tableData.length) {
          this.$message.error('只能添加一行数据');
          return;
        }
        // 表格新增
        let record = { ...this.addRowObj };
        this.$refs.table.validate().then(() => {
          this.$refs.table.insertAt(record, row).then(({ row }) => {
            this.$refs.table.setActiveRow(row);
          });
        });
      },
      deleteRow() {
        // 表格删除
        const selectedList = this.$refs.table.getSelectRecords();
        if (selectedList.length < 1) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noData'),
            type: 'error',
          });
        }
        // 当收款认领有二次认领信息时，如欲删除一次认领信息则会报错。必须先把二次认领信息删除才能删一次认领信息。
        let delFlag = false;
        selectedList.map((item) => {
          this.secondTableDataInit.map((i) => {
            console.log(item.id == i.firstClaimId);
            if (item.id == i.firstClaimId) {
              delFlag = true;
            }
          });
        });
        if (delFlag) {
          return this.$message({
            showClose: true,
            type: 'error',
            message: '所选收款一次认领存在对应二次认领，请先删除对应二次认领信息并保存！',
          });
        }
        this.$confirmAction()
          .then(() => {
            selectedList.map((item) => {
              if (item.id) {
                this.del.push(item.id);
              }
            });
            this.$refs.table.removeSelecteds();
          })
          .catch(() => {
            this.$message({ showClose: true, type: 'info', message: this.$t('message.cancelled') });
          });
      },
      async chkOrderSettle() {
        // 判断是否已关联结算批次
        let params = {
          associationType: '6',
          associationNoList: [this.formData.registerNo],
        };
        let res = await this.$baseRequest.chkOrderSettle(params);
        if (res) {
          if (res.code == 0) {
            this.handleSave();
          } else if (res.code == 10000) {
            this.$confirmAction('确认更改？', '该单据已关联结算批次，是否确认更改？')
              .then(() => {
                this.handleSave();
              })
              .catch(() => {
                this.$message({
                  showClose: true,
                  type: 'info',
                  message: this.$t('message.cancelled'),
                });
              });
          }
        }
      },
      // 保存一次认领
      async handleSave() {
        // 需选择待拆分数据才能进行保存
        if (!this.formData.id) {
          return this.tips('onlyOneSelectData', 'error');
        }
        let departmentNos = [];
        if (this.departmentList.length > 0) {
          departmentNos = this.departmentList.map((item) => {
            return item.value;
          });
        }
        // 基本信息
        let params = {
          id: this.formData.id,
          departmentNos: departmentNos,
        };
        // 一次认领
        let firstClaimInfo = await this.exportChildData();
        if (
          firstClaimInfo.fundCollectionFirstClaimList.some((item) => {
            return item.originReceiveMoneyAmount == 0;
          })
        ) {
          return this.tips('amountNoZero', 'error');
        }
        if (firstClaimInfo) {
          params = {
            ...params,
            ...firstClaimInfo,
          };
          this.$emit('saveData', params, 'SAVE_COLLECTIONCLAIM_FIRST');
        }
      },
      updateFooterEvent() {
        // 在值发生改变时更新表尾合计
        let xTable = this.$refs.table;
        xTable.updateFooter();
      },
      updateData() {
        // 在值发生改变时更新数据
        let xTable = this.$refs.table;
        xTable.updateData();
      },
      footerMethod({ columns, data }) {
        // 一次认领表尾合计
        let returnAmountProps = [
          'originProformaInvoiceAmount',
          'localProformaInvoiceAmount',
          'originReceiveMoneyAmount',
          'localReceiveMoneyAmount',
          'originDomesticBankDeductFee',
          'localDomesticBankDeductFee',
          'originForeignBankDeductFee',
          'localForeignBankDeductFee',
        ];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 1) {
              return this.$t('receivablesManage.receivablesClaimInfo.hasClaim');
            }
            if (returnAmountProps.includes(column.property)) {
              let subtrahend = 0;
              for (let i = 0; i < data.length; i++) {
                subtrahend = this.$cal.calCommon(data[i][column.property], subtrahend, '+');
              }
              return this.$baseRequest.formatTableColumn(subtrahend);
            }
            return null;
          }),
          columns.map((column, columnIndex) => {
            if (columnIndex === 1) {
              return this.$t('receivablesManage.receivablesClaimInfo.noClaim');
            }
            if (returnAmountProps.includes(column.property)) {
              let minuend = this.firstUnClaimedAmount[column.property];
              let subtrahend = 0;
              for (let i = 0; i < data.length; i++) {
                subtrahend = this.$cal.calCommon(data[i][column.property], subtrahend, '+');
              }
              return this.$baseRequest.formatTableColumn(
                this.$cal.calCommon(minuend, subtrahend, '-')
              );
            }
            return null;
          }),
        ];
      },
      // 金额校验，已认领金额不能大于总金额，当已认领金额等于总金额时，其他金额倒扣
      verifyAmount(val, row, prop, isChange) {
        let returnAmountProps = [
          'localReceiveMoneyAmount',
          'originDomesticBankDeductFee',
          'localDomesticBankDeductFee',
          'originForeignBankDeductFee',
          'localForeignBankDeductFee',
        ];
        let idx;
        if (prop == 'originProformaInvoiceAmount') {
          // 存在形式发票金额
          idx = 7;
          returnAmountProps = [
            'localProformaInvoiceAmount',
            'originReceiveMoneyAmount',
            ...returnAmountProps,
          ];
        } else {
          // 不存在形式发票金额，以收款金额为准
          idx = 9;
          returnAmountProps = [...returnAmountProps];
        }
        let sum = this.$refs.table.getTableData().footerData[0][idx];
        if (isChange) {
          // 合计金额不能超过总金额
          if (sum > this.firstUnClaimedAmount[prop]) {
            this.$message({
              showClose: true,
              message: this.$t('receivablesManage.message.calcInfo'),
              type: 'error',
            });
            if (prop == 'originProformaInvoiceAmount') {
              row.originProformaInvoiceAmount = 0;
            } else {
              row.originReceiveMoneyAmount = 0;
            }
            returnAmountProps.map((item) => {
              row[item] = 0;
            });
          }
        } else {
          // 当合计金额等于总金额时，最后一条数据其他计算所得金额倒扣
          if (sum == this.firstUnClaimedAmount[prop]) {
            let tableData = this.$refs.table.getTableData().fullData;
            let len = tableData.length;
            let otherIdx = idx + 1;
            returnAmountProps.map((item) => {
              let itemAmount = tableData[len - 1][item];
              let itemAmountSum = this.$refs.table.getTableData().footerData[0][otherIdx];
              tableData[len - 1][item] = this.$cal.calCommon(
                this.$cal.calCommon(this.firstUnClaimedAmount[item], itemAmountSum, '-'),
                itemAmount,
                '+',
                'amount'
              );
              otherIdx++;
            });
            // 更新数据
            this.updateData();
          }
        }
      },
      chooseTable(val, row, prop) {
        //let tableData = this.$refs.table.getTableData().tableData;
        // 客户
        if (prop == 'customerNo') {
          if (val && val.length > 0) {
            this.addRowObj.customerNo = row.customerNo = val[0].partnerCode;
            this.addRowObj.customerName = row.customerName = val[0].partnerZhName;
            /* tableData.map((item) => {
              item.customerNo = val[0].partnerCode;
              item.customerName = val[0].partnerZhName;
            }); */
          } else {
            this.addRowObj.customerNo = row.customerNo = null;
            this.addRowObj.customerName = row.customerName = null;
            /* tableData.map((item) => {
              item.customerNo = null;
              item.customerName = null;
            }); */
          }
        }
        // 供应商
        if (prop == 'claimPartnerNo') {
          if (val && val.length > 0) {
            this.addRowObj.claimPartnerNo = row.claimPartnerNo = val[0].partnerCode;
            this.addRowObj.claimPartnerName = row.claimPartnerName = val[0].partnerZhName;
            /* tableData.map((item) => {
              item.claimPartnerNo = val[0].partnerCode;
              item.claimPartnerName = val[0].partnerZhName;
            }); */
          } else {
            this.addRowObj.claimPartnerNo = row.claimPartnerNo = null;
            this.addRowObj.claimPartnerName = row.claimPartnerName = null;
            /* tableData.map((item) => {
              item.claimPartnerNo = null;
              item.claimPartnerName = null;
            }); */
          }
        }
        // 结算批次
        if (prop == 'settleBatchNo') {
          if (val && val.length > 0) {
            row.settleBatchNo = val[0].settleNo;
          } else {
            row.settleBatchNo = null;
          }
        }
        // 金额类
        if (prop.indexOf('Amount') != -1) {
          row[prop] = val;
          // let idx;
          if (prop == 'originProformaInvoiceAmount') {
            // 形式发票金额
            row.localProformaInvoiceAmount = this.calcLocalAmount(row.originProformaInvoiceAmount);
            let returnAmountProps = [
              'originReceiveMoneyAmount',
              'originDomesticBankDeductFee',
              'originForeignBankDeductFee',
            ];
            returnAmountProps.map((item) => {
              row[item] = this.calcOriginAmount(
                row.originProformaInvoiceAmount,
                this.formData.originProformaInvoiceAmount,
                this.formData[item]
              );
              row['local' + item.split('origin')[1]] = this.calcLocalAmount(row[item]);
            });
          } else {
            // 收款金额
            row.localReceiveMoneyAmount = this.calcLocalAmount(row.originReceiveMoneyAmount);
            let returnAmountProps = ['originDomesticBankDeductFee', 'originForeignBankDeductFee'];
            returnAmountProps.map((item) => {
              row[item] = this.calcOriginAmount(
                row.originReceiveMoneyAmount,
                this.formData.originReceiveMoneyAmount,
                this.formData[item]
              );
              row['local' + item.split('origin')[1]] = this.calcLocalAmount(row[item]);
            });
          }
          // 实时合计
          this.updateFooterEvent();
          this.verifyAmount(val, row, prop);
        }
      },
      chooseDepartment(val) {
        // 选择部门
        val.row.settleBatchNo = null;
        val.row.claimDepartmentName = val.row.claimDepartmentNo
          ? this.departmentList.find((item) => item.value == val.row.claimDepartmentNo).label
          : null;
      },
      chooseCustomer(val) {
        // 选择客户
        let tableData = this.$refs.table.getTableData().fullData;
        this.addRowObj.claimPartnerNo = this.addRowObj.claimPartnerName = null;
        this.addRowObj.customerNo = val.row.customerNo;
        this.addRowObj.customerName = val.row.customerNo
          ? this.partnerList.find((item) => item.value == val.row.customerNo).label
          : null;
        if (val.row.receivedType == 'RT18') {
          this.addRowObj.receivedType = val.row.receivedType = null;
        }
        tableData.map((item) => {
          item.claimPartnerNo = item.claimPartnerName = null;
          item.customerNo = this.addRowObj.customerNo;
          item.customerName = this.addRowObj.customerName;
          if (item.receivedType == 'RT18') {
            item.receivedType = null;
          }
        });
      },
      chooseClaimPartner(val) {
        // 选择供应商
        let tableData = this.$refs.table.getTableData().fullData;
        this.addRowObj.customerNo = this.addRowObj.customerName = null;
        this.addRowObj.claimPartnerNo = val.row.claimPartnerNo;
        this.addRowObj.claimPartnerName = val.row.claimPartnerNo
          ? this.partnerList.find((item) => item.value == val.row.claimPartnerNo).label
          : null;
        tableData.map((item) => {
          item.customerNo = item.customerName = null;
          item.claimPartnerNo = this.addRowObj.claimPartnerNo;
          item.claimPartnerName = this.addRowObj.claimPartnerName;
        });
      },
      calcOriginAmount(amountRow, totalAmountRow, returnTotalAmount) {
        // 计算原币
        // 当前行标识金额 * 最终所需返回金额的总额 / 标识金额总额
        let calcAmount1 = this.$cal.calCommon(amountRow, returnTotalAmount, '*');
        let calcAmount2 = this.$cal.calCommon(calcAmount1, totalAmountRow, '/', 'amount');
        return calcAmount2;
      },
      // 计算本币
      calcLocalAmount(originAmount) {
        return this.$cal.calCommon(originAmount, this.formData.exchangeRate, '*', 'amount');
      },
      // 返回数据
      exportChildData() {
        const [...tableData] = this.$refs.table.getTableData().fullData;
        // 点击提交，走校验
        if (tableData.length == 0) {
          return {
            fundCollectionFirstClaimList: [],
            delFundCollectionFirstClaimList: this.del,
          };
        } else {
          return new Promise((resolve) => {
            this.$refs.table
              .validate()
              .then(() => {
                let param = {
                  fundCollectionFirstClaimList: tableData,
                  delFundCollectionFirstClaimList: this.del,
                };
                resolve(param);
              })
              .catch((e) => {
                console.log(e);
              });
          });
        }
      },
      // 二次认领
      handleSecondClaim() {
        const selectedList = this.$refs.table.getSelectRecords(); // 获取选中数据
        console.log(selectedList, '--点击-->>');
        if (selectedList.length != 1) {
          return this.tips('onlyOneSelectData', 'error');
        } else if (!selectedList[0].id) {
          return this.tips('noFirstClaim', 'error');
        }
        // if (selectedList[0].receivedType != 'RT01') {
        //   return this.tips('onlyGoodsAmount', 'error');
        // }
        let item = {
          ...this.$refs.table.getSelectRecords()[0],
          registerId: this.formData.id,
          currency: this.formData.receiveInfoCurrencyName,
          isHNFlag: this.sysConfigFlag,
        };
        let secondTotalAmount = this.secondUnClaimAmountList.find(
          (it) => item.id == it.firstClaimId
        );
        item = {
          ...item,
          secondTotalAmount,
          settlementLineId: selectedList[0].id,
        };
        // http://hfpms.xinghy56.com/index.php?m=bug&f=view&bugID=3953
        if (['03', '04', '05'].includes(this.businessType)) {
          this.$refs.secondClaimDialog1Ref.openDialog(item);
        } else {
          this.$refs.secondClaimDialog.openDialog(true, item);
        }
        // this.$refs.secondClaimDialog.openDialog(true, item);
      },
      // 关联付款单
      handleAssociatedPayment() {
        const selectedList = this.$refs.table.getSelectRecords(); // 获取选中数据
        if (selectedList.length != 1) {
          return this.tips('onlyOneSelectData', 'error');
        }
        if (!selectedList[0].id) {
          return this.tips('noFirstClaim', 'error');
        }
        let isChanged = false;
        this.tableDataInit.map((item) => {
          if (selectedList[0].id == item.id) {
            isChanged =
              selectedList[0].receivedType != item.receivedType ||
              selectedList[0].claimDepartmentNo != item.claimDepartmentNo;
          }
        });
        if (isChanged) {
          return this.tips('noSupplierRefundSave', 'error');
        }
        // 只有供应商退款-非货款才能关联付款单
        if (['RT16'].indexOf(selectedList[0].receivedType) == -1) {
          return this.tips('noSupplierRefund', 'error');
        }
        let item = {
          ...this.$refs.table.getSelectRecords()[0],
          registerNo: this.formData.registerNo,
        };
        this.$refs.paymentDialog.openDialog(item);
      },
      handleSettleBatch() {
        // 关联结算批次
        const selectedList = this.$refs.table.getSelectRecords(); // 获取选中数据
        if (selectedList.length != 1) {
          return this.tips('onlyOneSelectData', 'error');
        }
        if (!selectedList[0].id) {
          return this.tips('noFirstClaim', 'error');
        }
        let extraData = {
          settleDepartmentNo: selectedList[0].claimDepartmentNo,
        };
        this.$refs.settlementBatch.open(extraData);
      },
      updateSettle(val) {
        // const selectedList = this.$refs.table.getSelectRecords(); // 获取选中数据
        let params = {
          ids: this.$refs.table.getSelectRecords().map((item) => {
            return item.id;
          }),
          settleBatchNo: val[0].settleNo,
        };
        this.$axios.post(API.UPDATE_SETTLE, params).then((res) => {
          if (res.data.code == 0) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.$refs.settlementBatch.close();
            this.getAllData(this.formData.id);
          } else {
            return this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      getAllData(registerId) {
        this.$emit('getAllData', registerId);
      },
      tips(info, type) {
        // 提示
        this.$message({
          showClose: true,
          message: this.$t(`receivablesManage.message.${info}`),
          type: type,
        });
      },
      receiveMethodCtrl(val) {
        // 收款方式逻辑控制
        let methodToType = {
          SK03: 'RT02', // 应收票据贴现
          SK04: 'RT03', // 应收票据托收
          SK05: 'RT12', // 应付票据保证金退回
          SK06: 'RT13', // 信用证保证金退回
          SK07: 'RT04', // 信用证收款
          SK08: 'RT08', // 期货保证金退回
        };
        this.addRowObj.receivedType = methodToType[val] ? methodToType[val] : null;
      },
      preclaimDepartmentCtrl(val) {
        // 预认领部门逻辑控制
        this.addRowObj.claimDepartmentNo = val.preclaimDepartmentCode;
        this.addRowObj.claimDepartmentName = val.preclaimDepartmentName;
      },
      payTypeCtrl(val) {
        // 付款单位类型逻辑控制
        if (val.payerType == 'HZHB02') {
          // 付款单位为供应商时，一次认领供应商默认付款单位
          this.claimPartnerNo = this.addRowObj.claimPartnerNo = val.payerCode;
          this.claimPartnerName = this.addRowObj.claimPartnerName = val.payerName;
          this.customerNo = this.addRowObj.customerNo = null;
          this.customerName = this.addRowObj.customerName = null;
        } else {
          // 付款单位为客户或者合作伙伴时，一次认领客户默认付款单位
          this.customerNo = this.addRowObj.customerNo = val.payerCode;
          this.customerName = this.addRowObj.customerName = val.payerName;
          this.claimPartnerNo = this.addRowObj.claimPartnerNo = null;
          this.claimPartnerName = this.addRowObj.claimPartnerName = null;
        }
      },
      updateCol(row, type) {
        // 切换收款类别
        if (type == 'receivedType') {
          console.log(row.receivedType, '111111===>');
          if (['RT07', 'RT15', 'RT16', '08', '14'].indexOf(row.receivedType) != -1) {
            console.log(222111);
            row['customerNo'] = null;
            row['customerName'] = null;
          } else {
            console.log(222);
            row['claimPartnerNo'] = null;
            row['claimPartnerName'] = null;
          }
          this.addRowObj.receivedType = row.receivedType;
        }
      },
    },
    watch: {
      'formData.registerCompanyCode': {
        // 公司
        handler(newValue) {
          this.getSysConfigByCompany(newValue);
        },
      },
      'formData.receiveMethod': {
        // 收款方式
        handler(newValue) {
          console.log(newValue);
          // this.receiveMethodCtrl(newValue); // 先注释
          this.$refs.table.getTableData().fullData.map((item) => {
            item.receivedType = this.addRowObj.receivedType;
          });
        },
      },
      'formData.preclaimDepartmentCode': {
        // 预认领部门
        handler() {
          this.preclaimDepartmentCtrl(this.formData);
          this.$refs.table.getTableData().fullData.map((item) => {
            item.claimDepartmentNo = this.addRowObj.claimDepartmentNo;
            item.claimDepartmentName = this.addRowObj.claimDepartmentName;
          });
        },
      },
      'formData.payerCode': {
        // 付款单位
        handler() {
          this.payTypeCtrl(this.formData);
          this.$refs.table.getTableData().fullData.map((item) => {
            ['customerNo', 'customerName', 'claimPartnerNo', 'claimPartnerName'].map((i) => {
              item[i] = this[i];
            });
          });
        },
      },
      'formData.isAnotherPay': {
        // 是否代付
        handler(newValue) {
          if (!newValue) {
            let tableData = this.$refs.table.getTableData().fullData;
            this.addRowObj.customerNo = this.customerNo;
            this.addRowObj.customerName = this.customerName;
            this.addRowObj.claimPartnerNo = this.claimPartnerNo;
            this.addRowObj.claimPartnerName = this.claimPartnerName;
            tableData.map((item) => {
              item.customerNo = this.customerNo;
              item.customerName = this.customerName;
              item.claimPartnerNo = this.claimPartnerNo;
              item.claimPartnerName = this.claimPartnerName;
            });
          }
        },
      },
      businessType: {
        handler(val) {
          this.computedReceivedTypeOptions(val);
        },
        immediate: true,
      },
    },
  };
</script>
<style scoped>
  ::v-deep .vxe-table--body {
    margin-bottom: 50px;
  }
</style>
